const cleanText = (value = "") =>
    String(value)
        .replace(/\s+/g, " ")
        .trim();

export function buildWomanImageAlt({ name, surname, category, achievement, place } = {}) {
    const fullName = cleanText(`${name || ""} ${surname || ""}`) || "persoană din proiect";
    const details = [cleanText(achievement), cleanText(category), cleanText(place)].filter(Boolean);

    if (details.length === 0) {
        return `Fotografie de profil cu ${fullName}`;
    }

    return `Fotografie de profil cu ${fullName}, ${details.join(", ")}`;
}
